import axios from 'axios';
import CryptoJS from "crypto-js";
import {useNavigate} from 'react-router-dom'
// const BASE_URL = 'https://jsonplaceholder.typicode.com/'; 
// http://192.168.1.116:5001/api

const BASE_URL=`${process.env.REACT_APP_BASE_URL}`

const instance = axios.create({
  baseURL: BASE_URL,  
  // timeout: 10000, 
  headers: {
    'Content-Type': 'application/json',
  },
  
});


let islogin =window.location.pathname
// Add request interceptor
instance.interceptors.request.use(
  
  (config) => {

    const token = JSON.parse(localStorage.getItem('token')); 
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    // if (true) {
    //   config.headers.Authorization = `Bearer JHDSGFHJSFG767345JKHGFJGDHJHJ`;
    // }
    return config;
  
  
  },
  (error) => {
    // Handle the request error here
    return Promise.reject(error);
  }
);

// Add response interceptor
instance.interceptors.response.use(
  (response) => {
    // You can process the response here before sending it back
    return response;
  },
  (error) => {
    // Handle specific response errors (e.g., token expiration, network issues)
    if (error.response && error.response.status === 401 && islogin !=="/login") {
      // Unauthorized error (e.g., token expired)
      // localStorage.setItem('isSuccess',false)
      localStorage.clear();
      // const navigate = useNavigate();
      // navigate('/login');
      // console.log("respose",error,error.response,error.response.status,error.response && error.response.status === 401)
      window.location.reload('');
      // window.location.href('/');
      // window.location.reload();
    }
  
    return Promise.reject(error);
  }
);

const get = async (url,headers = {}) => {
  try {
    const response = await instance.get(url, {
     
      headers: {
        ...headers, 
      },
    });
    return response.data;
  } catch (error) {
    handleAPIError(error);
    throw error;
  }
};

const post = async (url, data={}, headers = {}) => {
  try {
    const response = await instance.post(url, data, {
      headers: {
        ...headers, 
      },
    });
    return response.data;
  } catch (error) {
    handleAPIError(error);
    throw error;
  }
};
// params={}, 
const put = async (url,data={}, headers = {}) => {
  try {
    const response = await instance.put(url,data, {
      headers: {
        ...headers,
      },
    });
    return response.data;
  } catch (error) {
    handleAPIError(error);
    throw error;
  }
};

const deleteReq = async (url,headers) => {
  try {
    const response = await instance.delete(url, {
      headers: {
        ...headers,
      },
    });
    return response.data;
  } catch (error) {
    handleAPIError(error);
    throw error;
  }
};

const handleAPIError = (error) => {
  // console.error('API Error:', error.message);
};

const decryptResponse = (res) => {
  var bytes  = CryptoJS.AES.decrypt(res, 'secret key 123');
  var decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  return decryptedData;
}

const encryptResponse = (res) => {
  var encryptResponse = CryptoJS.AES.encrypt(JSON.stringify(res), 'secret key 123').toString();
  return encryptResponse
}

let key = CryptoJS.enc.Utf8.parse('4352678453967926');
let iv = CryptoJS.enc.Utf8.parse('4352678453967926');

  const encryptUsingAES256 = (data) => {
    var encrypted = CryptoJS.AES.encrypt(
      CryptoJS.enc.Utf8.parse(data),
      key,
      {
        keySize: 128 / 8,
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      }
    );
 
    return encrypted.toString();
  }

  const decryptUsingAES256 = (decString) => {
    const keys = crypto.getRandomValues(new Uint8Array(16)); 
    const secureKey = Array.from(keys, (byte) => ('00' + byte.toString(16)).slice(-2)).join('');

    var decrypted = CryptoJS.AES.decrypt(decString, key, {
      keySize: 128 / 8,
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });
    return decrypted.toString(CryptoJS.enc.Utf8)

  }

 

export { get, post,put,deleteReq,decryptUsingAES256,encryptUsingAES256 };
// 
